import {
  I2cIcon,
  I2cIconButton,
  I2cButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "./GuideCard.scss";
export const GuideCard = ({ guidStepObject, totalCount }) => {
  const {
    headerIcon = "",
    headerText = "",
    description,
    activeStep,
    onClickPrev,
    onClickNext,
    onClickClose,
    positionTop,
    positionRight,
    positionLeft,
  } = guidStepObject;
  return (
    <div
      className="card-overview"
      style={{
        top: positionTop,
        right: positionRight,
        left: positionLeft,
      }}
    >
      <div className="card-header">
        <span className="card-header-text">{headerText}</span>
        <I2cButton size="small" variant="link gray" onClick={onClickClose}>
          <I2cIcon name="cs-linear-close" label="close"></I2cIcon>
        </I2cButton>
      </div>
      <div className="card-body">
        {description}
        <br />
      </div>
      <div className="card-footer">
        <span className="card-footer-text">
          <span className="card-footer-text-active">{activeStep}</span>/
          {totalCount}
        </span>
        <span className="card-footer-action-button">
          {onClickPrev && (
            <I2cButton
              variant="secondary gray"
              className="card-footer-button"
              onClick={onClickPrev}
            >
              <I2cIcon name="cs-linear-chevron-left" label="Edit"></I2cIcon>
            </I2cButton>
          )}
          {onClickNext && (
            <I2cButton
              variant="secondary gray"
              className="card-footer-button"
              onClick={onClickNext}
            >
              <I2cIcon name="cs-linear-chevron-right" label="Edit"></I2cIcon>
            </I2cButton>
          )}
        </span>
      </div>
    </div>
  );
};
